import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function filterReducer(state = initialState.searchText, action: any) {
  switch (action.type) {
    case types.SAVE_FILTERSEARCHTEXT_SUCCESS:
      return action.searchText;
    default:
      return state;
  }
}
